import React from 'react'
import BrandItem from './components/BrandItem'

const SimpleFooter = () => {
  const brands = [
    {
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 21 20'>
          <g fill='#333' clipPath='url(#a)'>
            <path d='M7.794 11.27c0 .943-.307 1.507-.78 1.836-.485.343-1.172.471-1.987.471h-.1V6.418h1.38v-1H.917v1h1.25v7.16H.918v1h7.885V10.69H7.794v.579zm8.801-5.852v1h.572c.293 0 .493.057.607.136.107.071.165.186.165.372v3.336l-3.746-4.844h-3.918v1h.407c.38 0 .758.307.758.779v5.687c0 .343-.093.5-.186.579-.107.086-.257.121-.464.121h-.558v1h3.482v-1h-.437c-.192 0-.35-.007-.471-.028a.758.758 0 01-.265-.086c-.093-.064-.164-.186-.164-.514V7.86l5.176 6.724h1.322V6.89c0-.1.043-.207.143-.3.1-.093.279-.172.565-.172h.5v-1h-3.488z'></path>
          </g>
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M.5 0h20v20H.5z'></path>
            </clipPath>
          </defs>
        </svg>
      ),
      name: 'LA NACION',
      href: 'https://lanacion.com.ar',
    },
    {
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 21 20'>
          <path fill='#333' d='M4.78 7.295a6.844 6.844 0 012.182-1.466 7.022 7.022 0 012.672-.532c.908 0 1.849.174 2.673.532.824.35 1.557.841 2.181 1.466a6.845 6.845 0 011.466 2.181c.15.358.266.725.35 1.058a.915.915 0 001.115.7c.242-.05.458-.2.591-.417a.898.898 0 00.1-.716c-.125-.442-.258-.891-.45-1.316a8.794 8.794 0 00-1.864-2.772 8.609 8.609 0 00-2.773-1.865 8.85 8.85 0 00-3.405-.683 8.775 8.775 0 00-3.39.69 8.58 8.58 0 00-2.763 1.891A8.848 8.848 0 001.599 8.81a8.647 8.647 0 00-.682 3.39c0 1.166.225 2.356.666 3.405.025.059.05.117.083.184.025.041.042.091.058.133.15.333.483.541.85.541.166 0 .3-.042.383-.108.466-.233.666-.783.458-1.208-.025-.1-.075-.2-.117-.274a7.022 7.022 0 01-.533-2.673c0-.908.183-1.807.55-2.714A6.84 6.84 0 014.78 7.304v-.008z'></path>
          <path fill='#333' d='M6.046 11.774h4.887a.92.92 0 00.933-.932.931.931 0 00-.933-.933H6.046a.942.942 0 00-.933.933c0 .508.425.932.933.932zm13.104 1.399H6.088a.942.942 0 00-.932.933.94.94 0 00.932.932h13.064a.942.942 0 00.932-.932.942.942 0 00-.932-.933z'></path>
        </svg>
      ),
      name: 'CLUB LN',
      href: 'https://club.lanacion.com.ar',
    },
    {
      icon: (
        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 21 20'>
          <path fill='#333' d='M3.793 11.974l13.497 1.674c.28.033.39.373.195.569l-2.744 2.641s-.034.026-.05.034c-.595.195-6.014.094-6.38.085H8.27c-1.869-.416-3.746-2.098-4.825-4.561a.32.32 0 01.34-.442h.009zm1.189-7.721c.042-.042.11-.042.144.009l1.886 2.794s.051.051.085.068c.272.102 1.495.578 1.64.748.144.17.866 1.639 1.036 1.987a.105.105 0 01-.034.12l-.366.22s-.085.017-.119-.017L8.142 8.806l.688 1.588s0 .085-.034.11l-.51.324c-.042.025-.102.017-.127-.026l-.986-1.614.578 1.843s0 .085-.042.102l-.536.315c-.042.025-.101.008-.127-.034-.212-.4-1.147-2.14-1.13-2.65.009-.476.043-.994.06-1.156 0-.034 0-.068-.017-.093L4.54 4.839s-.008-.076.009-.102l.433-.492v.008zm7.653 2.345c1.384-1.19.577-3.084.365-3.517-.025-.05-.085-.06-.127-.025L9.127 5.85c-.043.034-.051.093-.009.136.374.348 2.124 1.818 3.517.62v-.008zm1.614 4.34l-.094 1.282c0 .043.026.085.077.094l.595.093c.042 0 .093-.025.101-.068l.323-1.316s1.962.586 2.098-1.062c.136-1.648-1.699-.951-1.699-.951s.298-1.308-1.019-1.376c-1.316-.068-1.138 1.138-1.138 1.138-1.19-.994-1.86.17-1.223.756l.476.442s-.79.934-.145 1.095c.654.162 1.648-.136 1.648-.136v.009z'></path>
        </svg>
      ),
      name: 'FOODIT',
      href: 'https://foodit.lanacion.com.ar',
    },
  ]
  return (
    <footer className='border border-top border-thin border-neutral-light-50 flex jc-center ai-center bg-neutral-light-1'>
      <div className='flex flex-column gap-16 py-32 px-16 px-24_md px-32_lg jc-center ai-center'>
        <p className='--arial text-14 text-center'>Un mundo de contenidos, experiencias y beneficios te espera</p>
        <ul className='flex gap-8'>
          {brands.map((brand, i) => (
            <React.Fragment key={i}>
              <li className='flex ai-center'>
                <BrandItem {...brand} />
              </li>
              {i < brands.length -1 && (
                <li className='flex ai-center'>
                  <svg width="4px" height="4px" xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 5 4'>
                    <circle cx='2.5' cy='2' r='2' fill='#CCC'></circle>
                  </svg>
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
      </div>
    </footer>
  )
}

export default SimpleFooter

